import classNames from 'classnames';
import * as PropTypes from 'prop-types';
import React from 'react';
import './Icon.scss';
import {
	AMLFire,
	AMLFlame,
	AMLScan,
	Allcoin,
	AmlCheck,
	AppleLogo,
	Arrow,
	ArrowBackwardSquare,
	ArrowBackwardSquareFill,
	ArrowBold,
	ArrowChevron,
	ArrowChevronBold,
	ArrowChevronCircle,
	ArrowChevronCircleFill,
	ArrowChevronUpDown,
	ArrowCircle,
	ArrowCircleFill,
	ArrowClockwise,
	ArrowClockwiseBold,
	ArrowSquareUp,
	ArrowSquareUpBold,
	ArrowSquareUpFill,
	ArrowTriangleheadSwap,
	ArrowTriangleheadSwapBbold,
	ArrowTriangleheadSwapCircle,
	ArrowTriangleheadSwapCircleFill,
	ArrowUpDown,
	ArrowUpDownBold,
	Backpack,
	BasketFill,
	BlueFuelPump,
	Bnbbc,
	Bnbbsc,
	Bnbsc,
	Book,
	Bookmark,
	Briefcase,
	BriefcaseFill,
	Btc,
	Calendar,
	Canceled,
	CarFill,
	Checkmark,
	CheckmarkCircle,
	CheckmarkCircleBold,
	CheckmarkCircleFill,
	Chevron,
	ClipboardFill,
	ClipboardIcon,
	Clock,
	ClockFill,
	CreditCard,
	CreditCardAnd123,
	CreditCardFill,
	Crown,
	Dai,
	DefaultAML,
	DeleteLeft,
	DeleteLeftFill,
	Devices,
	DiscordLogo,
	DocumentArrow,
	DocumentArrowFill,
	DocumentFill,
	DocumentIcon,
	DocumentPlus,
	DocumentPlusFill,
	DocumentsFill,
	DocumentsIcon,
	DocumentsIconPurple,
	DollarsIcon,
	Dollarsign,
	DollarsignCircle,
	DollarsignCircleBold,
	EmptyAccountListIcon,
	EmptyAssets,
	EmptyBhPage,
	EmptyCurrencyIcon,
	ErrorTriangle,
	Eth,
	European,
	ExclamationmarkCircle,
	ExclamationmarkCircleFill,
	ExclamationmarkTriangle,
	ExclamationmarkTriangleFill,
	EyeFill,
	EyeIcon,
	EyeSlash,
	EyeSlashFill,
	FacebookLogo,
	Flashlight,
	FlashlightSlash,
	ForkFill,
	GasPump,
	GasPumpCircle,
	GasPumpRim,
	Gb,
	Globe,
	GoogleLogo,
	GoogleWallet,
	Graduationcap,
	Hand,
	InfoCircle,
	InfoCircleFill,
	InstagramLogo,
	LanguageIcon,
	Laptop,
	Light,
	ListBullet,
	LoadingSpinner,
	LockFill,
	LockIcon,
	LockOpen,
	LockOpenFill,
	Ltc,
	Mastercard,
	Matic,
	Minus,
	MinusCircle,
	MinusCircleFill,
	Mobile,
	Near,
	Network,
	NotificationBell,
	NotificationBellBadge,
	NotificationBellBadgeFill,
	NotificationBellFill,
	PWAInstructionLogo,
	PaintBrush,
	PaperClip,
	Pencil,
	PencilCircle,
	PencilCircleFill,
	PencilLine,
	PencilSlash,
	PencilSquare,
	PencilSquareCircle,
	PencilSquareCircleFill,
	Percent,
	Person,
	PersonCircle,
	PersonCircleCheckmark,
	PersonCircleFill,
	PersonFill,
	Photo,
	PhotoFill,
	Plus,
	PlusBold,
	PlusCircle,
	PlusCircleFill,
	PlusSquare,
	QrCode,
	Questionmark,
	QuestionmarkCircle,
	QuestionmarkCircleFill,
	QuestionmarkDiamond,
	QuestionmarkDiamondFill,
	Russian,
	Search,
	SelectAllcoin,
	SettingsEllipsis,
	SettingsEllipsisBold,
	SettingsGear,
	SettingsGearshape,
	SettingsGearshapeFill,
	SettingsLine,
	SettingsSlider,
	Shield,
	ShieldFill,
	ShieldHalfFill,
	ShieldHalfFillExclamationmark,
	Snowflake,
	SnowflakeSlash,
	SnowflakeSlashBold,
	Star,
	StarFill,
	TelegramLogo,
	Toncoin,
	Touchid,
	Trash,
	TrashFill,
	Trx,
	TwitterLogo,
	USA,
	Ukraine,
	Usdc,
	Usdt,
	Viewfinder,
	ViewfinderFaceid,
	ViewfinderKey,
	ViewfinderQrcode,
	ViewfinderQrcodeScan,
	Visa,
	WalletFill,
	WalletLogo,
	WalletSimpleLogo,
	XLogo,
	Xmark,
	XmarkBold,
	XmarkCircle,
	XmarkCircleFill,
	Xrp,
} from './components';
import ArrowDropDown from './components/ArrowDropDown';
import ArrowSquareDown from './components/ArrowSquareDown';

export const Icons = {
	ARROW_CHEVRON: <ArrowChevron />,
	CHEVRON: <Chevron />,
	AML_CHECK: <AmlCheck />,
	PWA_INSTRUCTION_LOGO: <PWAInstructionLogo />,
	PLUS_SQUARE: <PlusSquare />,

	DefaultAML: <DefaultAML />,
	ErrorTriangle: <ErrorTriangle />,
	AML_FIRE: <AMLFire />,

	ARROW_CHEVRON_BOLD: <ArrowChevronBold />,
	ARROW_CHEVRON_CIRCLE: <ArrowChevronCircle />,
	ARROW_CHEVRON_CIRCLE_FILL: <ArrowChevronCircleFill />,
	ARROW_CHEVRON_UP_DOWN: <ArrowChevronUpDown />,
	ARROW: <Arrow />,
	ARROW_BOLD: <ArrowBold />,
	HAND: <Hand />,
	ARROW_CIRCLE: <ArrowCircle />,
	ARROW_CIRCLE_FILL: <ArrowCircleFill />,
	ARROW_CLOCKWISE: <ArrowClockwise />,
	ARROW_CLOCKWISE_BOLD: <ArrowClockwiseBold />,
	ARROW_UP_DOWN: <ArrowUpDown />,
	ARROW_UP_DOWN_BOLD: <ArrowUpDownBold />,
	ARROW_TRIANGLEHEAD_SWAP: <ArrowTriangleheadSwap />,
	ARROW_TRIANGLEHEAD_SWAP_BOLD: <ArrowTriangleheadSwapBbold />,
	ARROW_TRIANGLEHEAD_SWAP_CIRCLE: <ArrowTriangleheadSwapCircle />,
	ARROW_TRIANGLEHEAD_SWAP_CIRCLE_FILL: <ArrowTriangleheadSwapCircleFill />,
	ARROW_BACKWARD_SQUARE: <ArrowBackwardSquare />,
	ARROW_BACKWARD_SQUARE_FILL: <ArrowBackwardSquareFill />,
	ARROW_SQUARE_DOWN: <ArrowSquareDown />,
	ARROW_SQUARE_UP: <ArrowSquareUp />,
	ARROW_SQUARE_UP_BOLD: <ArrowSquareUpBold />,
	ARROW_SQUARE_UP_FILL: <ArrowSquareUpFill />,
	ARROW_DROP_DOWN: <ArrowDropDown />,
	BLUE_FUEL_PUMP: <BlueFuelPump />,
	BRIEFCASE: <Briefcase />,
	BRIEFCASE_FILL: <BriefcaseFill />,
	PLUS: <Plus />,
	PLUS_BOLD: <PlusBold />,
	PLUS_CIRCLE: <PlusCircle />,
	PLUS_CIRCLE_FILL: <PlusCircleFill />,
	XMARK: <Xmark />,
	XMARK_BOLD: <XmarkBold />,
	XMARK_CIRCLE: <XmarkCircle />,
	XMARK_CIRCLE_FILL: <XmarkCircleFill />,
	DELETE_LEFT: <DeleteLeft />,
	DELETE_LEFT_FILL: <DeleteLeftFill />,
	MINUS: <Minus />,
	MINUS_CIRCLE: <MinusCircle />,
	MINUS_CIRCLE_FILL: <MinusCircleFill />,
	CANCELED: <Canceled />,
	EMPTY_CURRENCY_ICON: <EmptyCurrencyIcon />,
	EMPTY_ACCOUNT_LIST_ICON: <EmptyAccountListIcon />,
	CHECKMARK: <Checkmark />,
	CHECKMARK_CIRCLE: <CheckmarkCircle />,
	CHECKMARK_CIRCLEBold: <CheckmarkCircleBold />,
	CHECKMARK_CIRCLE_FILL: <CheckmarkCircleFill />,
	EXCLAMATIONMARK_CIRCLE: <ExclamationmarkCircle />,
	EXCLAMATIONMARK_CIRCLE_FILL: <ExclamationmarkCircleFill />,
	EXCLAMATIONMARK_TRIANGLE_FILL: <ExclamationmarkTriangleFill />,
	EXCLAMATIONMARK_TRIANGLE: <ExclamationmarkTriangle />,
	QUESTIONMARK: <Questionmark />,
	QUESTIONMARK_CIRCLE: <QuestionmarkCircle />,
	QUESTIONMARK_CIRCLE_FILL: <QuestionmarkCircleFill />,
	QUESTIONMARK_DIAMOND: <QuestionmarkDiamond />,
	QUESTIONMARK_DIAMOND_FILL: <QuestionmarkDiamondFill />,
	INFO_CIRCLE: <InfoCircle />,
	INFO_CIRCLE_FILL: <InfoCircleFill />,
	DOLLARSIGN: <Dollarsign />,
	DOLLARSIGN_CIRCLE: <DollarsignCircle />,
	DOLLARSIGN_CIRCLE_BOLD: <DollarsignCircleBold />,
	NOTIFICATION_BELL: <NotificationBell />,
	LIGHT: <Light />,
	NOTIFICATION_BELL_FILL: <NotificationBellFill />,
	NOTIFICATION_BELL_BADGE: <NotificationBellBadge />,
	NOTIFICATION_BELL_BADGE_FILL: <NotificationBellBadgeFill />,
	AML_SCAN: <AMLScan />,
	VIEWFINDER: <Viewfinder />,
	QR_CODE: <QrCode />,
	VIEWFINDER_QRCODE: <ViewfinderQrcode />,
	VIEWFINDER_QRCODE_SCAN: <ViewfinderQrcodeScan />,
	VIEWFINDER_FACEID: <ViewfinderFaceid />,
	VIEWFINDER_KEY: <ViewfinderKey />,
	SHIELD: <Shield />,
	EYE_ICON: <EyeIcon />,
	EYE_SLASH: <EyeSlash />,
	TOUCHID: <Touchid />,
	NETWORK: <Network />,
	LOCK_ICON: <LockIcon />,
	LOCK_OPEN: <LockOpen />,
	SHIELD_FILL: <ShieldFill />,
	SHIELD_HALF_FILL: <ShieldHalfFill />,
	LANGUAGE_ICON: <LanguageIcon />,
	CREDIT_CARD_AND_123: <CreditCardAnd123 />,
	GLOBE: <Globe />,
	PERCENT: <Percent />,
	DOLLARS_ICON: <DollarsIcon />,
	EYE_FILL: <EyeFill />,
	PAPER_CLIP: <PaperClip />,
	ENGLISH: <Gb />,
	DEVICES: <Devices />,
	EYE_SLASH_FILL: <EyeSlashFill />,
	LOADING_SPINNER: <LoadingSpinner />,
	RUSSIAN: <Russian />,
	LOCK_FILL: <LockFill />,
	LOCK_OPEN_FILL: <LockOpenFill />,
	SHIELD_HALF_FILL_EXCLAMATIONMARK: <ShieldHalfFillExclamationmark />,
	SETTINGS_SLIDER: <SettingsSlider />,
	SETTINGS_GEAR: <SettingsGear />,
	SETTINGS_ELLIPSIS: <SettingsEllipsis />,
	SETTINGS_ELLIPSIS_BOLD: <SettingsEllipsisBold />,
	SETTINGS_LINE: <SettingsLine />,
	SETTINGS_GEARSHAPE: <SettingsGearshape />,
	SETTINGS_GEARSHAPE_FILL: <SettingsGearshapeFill />,
	CLOCK: <Clock />,
	LAPTOP: <Laptop />,
	CALENDAR: <Calendar />,
	CLOCK_FILL: <ClockFill />,
	DOCUMENTS_ICON: <DocumentsIcon />,
	DOCUMENTS_ICON_PURPLE: <DocumentsIconPurple />,
	DOCUMENT_ICON: <DocumentIcon />,
	DOCUMENT_PLUS: <DocumentPlus />,
	DOCUMENT_ARROW: <DocumentArrow />,
	PAINT_BRUSH: <PaintBrush />,
	PENCIL: <Pencil />,
	PENCIL_CIRCLE: <PencilCircle />,
	PENCIL_SLASH: <PencilSlash />,
	PENCIL_LINE: <PencilLine />,
	PENCIL_SQUARE: <PencilSquare />,
	PENCIL_SQUARE_CIRCLE: <PencilSquareCircle />,
	CLIPBOARD_ICON: <ClipboardIcon />,
	FLASHLIGHT_SLASH: <FlashlightSlash />,
	FLASHLIGHT: <Flashlight />,
	DOCUMENTS_FILL: <DocumentsFill />,
	DOCUMENT_FILL: <DocumentFill />,
	DOCUMENT_PLUS_FILL: <DocumentPlusFill />,
	DOCUMENT_ARROW_FILL: <DocumentArrowFill />,
	PENCIL_CIRCLE_FILL: <PencilCircleFill />,
	PENCIL_SQUARE_CIRCLE_FILL: <PencilSquareCircleFill />,
	CLIPBOARD_FILL: <ClipboardFill />,
	APPLE_LOGO: <AppleLogo />,
	GOOGLE_LOGO: <GoogleLogo />,
	GOOGLE_WALLET: <GoogleWallet />,
	LIST_BULLET: <ListBullet />,
	TRASH: <Trash />,
	TRASH_FILL: <TrashFill />,
	WALLET_FILL: <WalletFill />,
	CREDIT_CARD: <CreditCard />,
	CREDIT_CARD_FILL: <CreditCardFill />,
	PERSON: <Person />,
	PERSON_CIRCLE: <PersonCircle />,
	PERSON_FILL: <PersonFill />,
	PERSON_CIRCLE_FILL: <PersonCircleFill />,

	PHOTO: <Photo />,
	PHOTO_FILL: <PhotoFill />,
	STAR: <Star />,
	STAR_FILL: <StarFill />,
	SNOWFLAKE: <Snowflake />,
	SNOWFLAKE_SLASH: <SnowflakeSlash />,
	SNOWFLAKE_SLASH_BOLD: <SnowflakeSlashBold />,
	SEARCH: <Search />,
	SELECT_ALLCOIN: <SelectAllcoin />,
	ALLCOIN: <Allcoin />,
	ETH: <Eth />,
	DAI: <Dai />,
	TRX: <Trx />,
	USDT: <Usdt />,
	USDC: <Usdc />,
	BTC: <Btc />,
	BNB: <Bnbbsc />,
	BSC: <Bnbbsc />,
	BNBBSC: <Bnbbsc />,
	MATIC: <Matic />,
	MOBILE: <Mobile />,
	NEAR: <Near />,
	XRP: <Xrp />,
	Toncoin: <Toncoin />,
	BNBBC: <Bnbbc />,
	BNBSC: <Bnbsc />,
	LTC: <Ltc />,
	WALLET_SIMPLE_LOGO: <WalletSimpleLogo />,
	Credits: <WalletLogo />,
	INSTAGRAM_LOGO: <InstagramLogo />,
	TELEGRAM_LOGO: <TelegramLogo />,
	FACEBOOK_LOGO: <FacebookLogo />,
	XLOGO: <XLogo />,
	TWITTER_LOGO: <TwitterLogo />,
	DISCORD_LOGO: <DiscordLogo />,
	EUROPEAN: <European />,
	UKRAINE: <Ukraine />,
	USA: <USA />,
	CROWN: <Crown />,
	BOOK: <Book />,
	GRADUATIONCAP: <Graduationcap />,
	BACKPACK: <Backpack />,
	BOOKMARK: <Bookmark />,
	BASKET_FILL: <BasketFill />,
	FORK_FILL: <ForkFill />,
	CAR_FILL: <CarFill />,
	EMPTY_BH_PAGE: <EmptyBhPage />,
	PERSON_CIRCLE_CHECKMARK: <PersonCircleCheckmark />,
	GAS_PUMP: <GasPump />,
	AMLFlame: <AMLFlame />,
	GAS_PUMP_CIRCLE: <GasPumpCircle />,
	GAS_PUMP_RIM: <GasPumpRim />,
	MASTERCARD: <Mastercard />,
	VISA: <Visa />,
	EMPTY_ASSETS: <EmptyAssets />,
	PAPER_CLIP: <PaperClip />,
};

const Icon = ({
	id = null,
	className = null,
	type = '',
	width = 15,
	height = 15,
	disabled = false,
	onClick,
	...props
}) => {
	const handleClick = e => {
		if (!disabled && onClick) onClick(e);
	};

	return (
		<i
			id={id}
			className={classNames('icon', className, { disabled })}
			onClick={handleClick}
			style={{
				display: 'flex',
				width: width + 'px',
				height: height + 'px',
			}}
			{...props}
		>
			{type}
		</i>
	);
};

Icon.propTypes = {
	id: PropTypes.string,
	className: PropTypes.string,
	type: PropTypes.object,
	width: PropTypes.number,
	height: PropTypes.number,
	disabled: PropTypes.bool,
};

export default Icon;
